import { defineMessages } from 'react-intl'

/** Event brands and checkout payment / gift-card copy — `docs/product-taxonomy.md` §13. */
const paymentsGlossaryMessages = defineMessages({
  luxuryEscapesLive: {
    defaultMessage: 'Luxury Escapes Live',
    id: 'hUnE-N-5qXjXoWzYp7I1',
    description: 'Event brand name for LE Live in-person and virtual travel show marketing',
  },
  luxuryEscapesLive2026: {
    defaultMessage: 'Luxury Escapes Live 2026',
    id: 'CbnSx43i1lNwtP4bxNka',
    description: 'Dated year-specific title for Luxury Escapes Live event campaigns and registration',
  },
  exclusiveEventOnlyOffers: {
    defaultMessage: 'Exclusive event-only offers',
    id: 'M1ZK034tpymaRL2TjKmh',
    description: 'Banner for inventory and pricing only available during an LE Live or similar event',
  },
  dontMissLuxuryEscapesLive: {
    defaultMessage: "Don't Miss Luxury Escapes Live",
    id: 'kHOzDk52s67LlKxgWeFz',
    description: 'Promotional CTA for driving attendance or engagement with the Luxury Escapes Live event',
  },
  luxPay: {
    defaultMessage: 'LuxPay',
    id: 'LZ6UfDG1CzdRaSh2aPbT',
    description: 'Product name for the LuxPay deferred or instalment payment option at checkout',
  },
  payWithGiftCard: {
    defaultMessage: 'Pay with Gift Card',
    id: 'lHKQzbnqNxTi6C8GOppt',
    description: 'Checkout payment option to apply one or more gift cards toward the order balance',
  },
  addAGiftCard: {
    defaultMessage: 'Add a Gift Card',
    id: 'kuI0t4y_oLWwrOeFpHS4',
    description: 'Call-to-action in checkout to add another gift card or open the gift card entry form',
  },
})

export default paymentsGlossaryMessages
